import axios from "axios";
import router from '@/router';
import store from "@/store";

import { expiredTokenHandler } from "./ExpiredTokenHandler";

const PERMISSION_CODES = new Set([70030, 70031, 70032, 70033]);

const createInstance = () => {
    const apiPreUrl = window.location.protocol + '//' + window.location.hostname + ':8008';
    const instance = axios.create({ baseURL: apiPreUrl });
    return setInterceptor(instance);
}

const refreshPermissions = async () => {
    try {
        await store.dispatch('naviList/list');
    } catch (error) {
        console.error('[permission] 메뉴 정보를 새로고침하지 못했습니다.', error);
    }
};

const setInterceptor = (instance) => {
    instance.interceptors.request.use(function (config) {
        if (!config.url.endsWith('/api/auth/login')) {
            config.headers.Authorization = `Bearer ${sessionStorage.getItem("AccessToken")}`;
        }
        if (!(config.data instanceof FormData)) {
            config.headers["Content-Type"] = "application/json";
        }
        return config;
    });

    let isHandling401 = false; 
    let isHandlingPermission = false;

    instance.interceptors.response.use(
        async (response) => {
            const payloadStatus = Number(response?.data?.status);
            if (PERMISSION_CODES.has(payloadStatus)) {
                if (!isHandlingPermission) {
                    isHandlingPermission = true;
                    await refreshPermissions();
                    isHandlingPermission = false;
                }
                return Promise.reject({ response });
            }

            if (response.status === 401) {
                return await expiredTokenHandler(response);
            }

            return response;
        },
        async (error) => {
            if (error.response && error.response.status === 401) {
                if (!isHandling401) {
                    isHandling401 = true;

                    sessionStorage.removeItem("AccessToken");
                    store.commit('user/setAccessToken', null);
                    store.commit('user/SET_LOGIN_STATUS', false);

                    if (router.currentRoute.path !== '/') {
                        window.alert('세션이 만료되었습니다. 다시 로그인해주세요.'); 
                        router.push({ path: '/' });
                    }
                }
            }
            return error;

        }
    );
    return instance;
}

const globalAxios = createInstance();

export default globalAxios;



// import axios from "axios";
// import router from '@/router';
// import store from "@/store";

// import { expiredTokenHandler } from "./ExpiredTokenHandler";

// const createInstance = () => {
//     // const apiPreUrl = store.getters['Url/setApiPreUrl'];
//     const apiPreUrl = window.location.protocol + '//' + window.location.hostname + ':8008';
//     //const frontPreUrl = window.location.protocol + '//' + window.location.host;
//     //console.log('api', apiPreUrl);
//     const instance = axios.create({ baseURL: apiPreUrl });
//     return setInterceptor(instance);
// }

// const setInterceptor = (instance) => {
//     instance.interceptors.request.use(function (config) {
        
//         // config.headers.AccessToken = localStorage.getItem("AccessToken");
//         if (!config.url.endsWith('/api/auth/login')) {
//             config.headers.Authorization = `Bearer ${sessionStorage.getItem("AccessToken")}`;
//         }
//         //config.headers["Content-Type"] = "application/json";
//         if (!(config.data instanceof FormData)) {
//             config.headers["Content-Type"] = "application/json";
//         }
//         //config.headers['Access-Control-Allow-Origin'] = '*';


//         // console.log('Sending Request to:', config.url);
//         // console.log('Request Headers:', config.headers);

//         return config;
//     });

//     instance.interceptors.response.use(
//         async (response) => {
//             // if (response.status === 401) {
//             //     return await expiredTokenHandler(response);
//             // }

//             // console.log('Response from:', response.config.url);
//             // console.log('Response Headers:', response.headers); 

//             return response;
//         },
//         async (error) => {
//             if (error.response && error.response.status === 401) {
//                 // return await expiredTokenHandler(error.response);
//                 // try {
//                 //     return await expiredTokenHandler(error.response);
//                 // } catch (e) {
//                 //     return Promise.reject(e);
//                 // }
//                 sessionStorage.removeItem("AccessToken");
//                 store.commit('user/setAccessToken', null);
//                 store.commit('user/SET_LOGIN_STATUS', false);

//                 window.alert('세션이 만료되었습니다. 다시 로그인해주세요.');
//                 // window.alert('세션이 만료되었습니다. 다시 로그인해주세요.\n' + (error?.message || JSON.stringify(error)));
//                 console.error('Token refresh failed:', error?.message || JSON.stringify(error));

//                 if (router.currentRoute.path !== '/') {
//                     // router.replace({ path: '/', query: { redirect: router.currentRoute.fullPath } });
//                     router.push({path: '/'});
//                 }

//                 return Promise.reject(error);
//             }
//             //console.error('Response Error:', error);
//             // return Promise.reject("에러 확인 => ", error);
//             return Promise.reject(error);

//         }
//     );
//     return instance;
// }

// const globalAxios = createInstance();

// export default globalAxios;
